import React from 'react'
import { Card, CardBody, ListGroup, ListGroupItem, Table, Row, Col, Spinner } from 'reactstrap'
import { Navigate, useNavigate } from 'react-router-dom'
import { ArrowLeft, Info } from 'react-feather'
import { P } from 'components'
import { useGetAutoNumberConfigsQuery } from '../settingApiSlice'
import ConfigRow from './ConfigRow'
import { useAbilityAccess } from 'hooks/useAbilityAccess'
import { URL_406 } from 'utils/pathUrl'

const AutoNumberSetting = ({ action, subject }) => {
  const navigate = useNavigate()
  const { data: configs, isLoading, refetch } = useGetAutoNumberConfigsQuery()

  const buyConfig = configs?.find((c) => c.type === 'BUY')
  const sellConfig = configs?.find((c) => c.type === 'SELL')
  const invConfig = configs?.find((c) => c.type === 'INV')
  const xferConfig = configs?.find((c) => c.type === 'XFER')

  const now = new Date()
  const exM = now.getMonth() + 1
  const exMM = String(exM).padStart(2, '0')
  const exMMM = now.toLocaleString('id-ID', { month: 'short' })
  const exMMMM = now.toLocaleString('id-ID', { month: 'long' })
  const exYY = String(now.getFullYear()).slice(2)
  const exYYYY = now.getFullYear()

  return (
    <CardBody className="p-0 p-md-3">
      <ListGroup flush>
        <div className="p-2 p-md-4" style={{ backgroundColor: '#F8F9FA', minHeight: '60vh' }}>
          {isLoading ? (
            <div className="text-center py-5">
              <Spinner color="primary" />
            </div>
          ) : (
            <Card className="border-0" style={{ borderRadius: '12px', boxShadow: '0 4px 12px rgba(0,0,0,0.04)' }}>
              <ListGroup flush style={{ borderRadius: '12px' }}>
                <ConfigRow type="BUY" config={buyConfig} otherConfigs={[sellConfig, invConfig, xferConfig]} refetch={refetch} />
                <ConfigRow type="SELL" config={sellConfig} otherConfigs={[buyConfig, invConfig, xferConfig]} refetch={refetch} />
                <ConfigRow type="INV" config={invConfig} otherConfigs={[buyConfig, sellConfig, xferConfig]} refetch={refetch} />
                <ConfigRow type="XFER" config={xferConfig} otherConfigs={[buyConfig, sellConfig, invConfig]} refetch={refetch} />
              </ListGroup>
            </Card>
          )}

          <Card className="mt-3 mt-md-4 border-0" style={{ borderRadius: '12px', boxShadow: '0 4px 12px rgba(0,0,0,0.04)' }}>
            <div className="p-3 p-md-4 border-bottom d-flex align-items-center gap-2">
              <Info size={20} className="text-primary" />
              <P size="large" bold className="mb-0">Daftar Kode (Variabel)</P>
            </div>
            <CardBody className="p-0">
              <Table responsive hover className="mb-0" style={{ fontSize: '14px' }}>
                <thead className="bg-light text-muted">
                  <tr>
                    <th className="px-3 px-md-4 py-3 border-bottom-0 fw-medium">Kode</th>
                    <th className="px-3 px-md-4 py-3 border-bottom-0 fw-medium">Keterangan</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="px-3 px-md-4 py-3"><code className="bg-light px-2 py-1 rounded text-primary">{'{M}'}</code></td>
                    <td className="px-3 px-md-4 py-3 text-muted">Angka bulan (contoh: {exM})</td>
                  </tr>
                  <tr>
                    <td className="px-3 px-md-4 py-3"><code className="bg-light px-2 py-1 rounded text-primary">{'{MM}'}</code></td>
                    <td className="px-3 px-md-4 py-3 text-muted">Angka bulan dengan awalan nol (contoh: {exMM})</td>
                  </tr>
                  <tr>
                    <td className="px-3 px-md-4 py-3"><code className="bg-light px-2 py-1 rounded text-primary">{'{MMM}'}</code></td>
                    <td className="px-3 px-md-4 py-3 text-muted">Singkatan nama bulan (contoh: {exMMM})</td>
                  </tr>
                  <tr>
                    <td className="px-3 px-md-4 py-3"><code className="bg-light px-2 py-1 rounded text-primary">{'{MMMM}'}</code></td>
                    <td className="px-3 px-md-4 py-3 text-muted">Nama bulan penuh (contoh: {exMMMM})</td>
                  </tr>
                  <tr>
                    <td className="px-3 px-md-4 py-3"><code className="bg-light px-2 py-1 rounded text-primary">{'{YY}'}</code></td>
                    <td className="px-3 px-md-4 py-3 text-muted">Tahun 2 digit (contoh: {exYY})</td>
                  </tr>
                  <tr>
                    <td className="px-3 px-md-4 py-3"><code className="bg-light px-2 py-1 rounded text-primary">{'{YYYY}'}</code></td>
                    <td className="px-3 px-md-4 py-3 text-muted">Tahun 4 digit (contoh: {exYYYY})</td>
                  </tr>
                  <tr>
                    <td className="px-3 px-md-4 py-3"><code className="bg-light px-2 py-1 rounded text-primary">{'{SEQ}'}</code></td>
                    <td className="px-3 px-md-4 py-3 text-muted">Nomor urut auto increment</td>
                  </tr>
                </tbody>
              </Table>
            </CardBody>
          </Card>
        </div>
      </ListGroup>
    </CardBody>
  )
}

export default AutoNumberSetting
